import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import axiosInstance from '../../axiosInstance';
import '../../styles/ProjectPeriod.css'
import AsyncSelect from "react-select/async";

const ProjectPeriodPopup = ({ closePopup, editData, triggerReload }) => {
  const [selectedProject, setSelectedProject] = useState(null); 

  const [formData, setFormData] = useState({
    project_code: '',
    period_type: '',
    period: '',
    break_period_value: '',
    break_periods: []
  });

  const [isEditing, setIsEditing] = useState(false);

useEffect(() => {
  if (editData?.id) {
    const fetchData = async () => {
      try {
        const { data } = await axiosInstance.get(
          `/costsolution/projectperiod/get/${editData.id}`
        );

        if (data.projectperiod) {
          const projectPeriod = data.projectperiod;
          console.log("Project Period Object:", projectPeriod); // Debug log
          setFormData({
            project_code: projectPeriod.projectId || '',
            period_type: projectPeriod.periodType || '',
            period: projectPeriod.period || '',
            break_period_value: projectPeriod.breakPeriodValue || '',
            break_periods: projectPeriod.projectPeriodBreaks.map(b => b.month.toString()) || []
          });
          
          if (projectPeriod.projectName) {
            setSelectedProject({
              value: projectPeriod.projectId,
              label: projectPeriod.projectName
            });
          }
          
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Error fetching project period details");
      }
    };
    fetchData();
  }
}, [editData?.id])

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'break_period_value') {
      const num = parseInt(value) || 0;
      const newBreakPeriods = Array(num).fill('').map((val, index) => 
        formData.break_periods[index] || ''
      );
      
      setFormData(prev => ({ 
        ...prev, 
        [name]: value,
        break_periods: newBreakPeriods
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleBreakPeriodChange = (index, value) => {
    const newBreakPeriods = [...formData.break_periods];
    newBreakPeriods[index] = value;
    setFormData(prev => ({ ...prev, break_periods: newBreakPeriods }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Convert break periods to numbers and validate
  const breakPeriodsNum = formData.break_periods.map(p => parseFloat(p) || 0);
  const totalBreak = breakPeriodsNum.reduce((acc, val) => acc + val, 0);
  const periodNum = parseFloat(formData.period) || 0;
  
  if (totalBreak !== periodNum) {
    toast.error("Total of break periods must be equal to the period value.");
    return;
  }

  // Prepare break periods data structure
  const projectPeriodBreaks = formData.break_periods.map((value, index) => ({
    id: 0,
    tag: `Period${index + 1}`,
    month: parseFloat(value) || 0,
    projectPeriodId: null,
    orgid: null
  }));

  const projectPeriodData = {
    project_code: formData.project_code,
    periodType: formData.period_type,
    period: formData.period,
    breakPeriodValue: formData.break_period_value,
    projectPeriodBreaks: projectPeriodBreaks
  };

  try {
    const url = isEditing
      ? `/costsolution/projectperiod/${editData.id}`
      : `/costsolution/projectperiod`;
    const method = isEditing ? "put" : "post";

    const response = await axiosInstance[method](url, projectPeriodData);

      if (response.data.success) {
        toast.success(
          isEditing
            ? "Project period updated successfully!"
            : "Project period created successfully!"
        );
        triggerReload();
        closePopup();
      } else {
        // Show backend validation message
        const message = response.data.message || "Error processing request";
        toast.error(message);
      }
    } catch (error) {
      console.error("Error:", error);

      // If backend sends validation in error.response.data
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong!");
      }
    }
  };

const handleProjectSelect = (selectedOption) => {
  setSelectedProject(selectedOption);
  setFormData(prev => ({
    ...prev,
    project_code: selectedOption ? selectedOption.value : ''
  }));
};

  const handleClear = () => {
    setFormData({
      project_code: '',
      period_type: '',
      period: '',
      break_period_value: '',
      break_periods: []
    });
  };

  const loadProjectOptions = async (inputValue, callback) => {
      console.log("Searching for projects with:", inputValue);

      try {
          const res = await axiosInstance.get(
              "/costsolution/projects/autosuggestion",
              {
                  params: { term: inputValue || '' }
              }
          );

          const projects = res.data?.autosuggestion || [];

          // Filter so only uppercase matching labels are returned
          const filtered = projects.filter(item =>
              item.label.toUpperCase().includes(inputValue.toUpperCase())
          );

          const mapped = filtered.map((item) => ({
              label: item.label,
              value: item.value,
          }));

          console.log("Filtered + Mapped project options:", mapped);
          callback(mapped);
      } catch (error) {
          console.error("Project suggestion error:", error);
          callback([]);
      }
  }

  return (
    <div className="project-period-popup-overlay">
      <div className="project-period-popup-container">
        <div className="project-period-popup-header">
          <h2>{isEditing ? "Edit Project Period" : "Create Project Period"}</h2>
          <button className="close-button" onClick={closePopup}>
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="project-period-popup-body">
            <div className="project-period-form-group">
              <label htmlFor="project" className="labels">Project</label>
           <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadProjectOptions}
               onChange={handleProjectSelect}
              value={selectedProject}
              placeholder="Search project..."
              isClearable
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: '34px',
                  borderRadius: '8px',
                  fontSize: '13px',
                  width: '100%',
                  borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                  boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                  '&:hover': {
                    borderColor: '#454CF2'
                  }
                }),
                container: (base) => ({
                  ...base,
                  width: '100%'
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 999,
                  fontSize: '13px',
                  marginTop: '4px',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: '180px',  
                  overflowY: 'auto', 
                  padding: 0          
                }),
                option: (base, { isFocused }) => ({
                  ...base,
                  backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                  color: '#333',
                  padding: '8px',
                  height: '30px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee',
                  '&:active': {
                    backgroundColor: '#f2f2f2'
                  }
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: '8px'
                }),
                clearIndicator: (base) => ({
                  ...base,
                  padding: '8px'
                })
              }}
            />
            </div>

            <div className="project-period-form-group">
              <label htmlFor="periodType" className="name">Period Type</label>
              <select 
                className="project-popup-input" 
                style={{height:'37px',borderRadius:'8px',padding:'8px'}}
                name="period_type"
                value={formData.period_type}
                onChange={handleChange}
              >
                <option value="" disabled>Select</option>
                <option value="month">Month</option>
                <option value="year">Year</option>
              </select>
            </div>

            <div className="project-period-form-group">
              <label htmlFor="period" className="name">Period</label>
              <input
                type="text"
                id="period"
                name="period"
                value={formData.period}
                onChange={handleChange}
                required
                style={{ margin: "0px", fontSize: '12px' }}
              />
            </div>

            <div className="project-period-form-group">
              <label htmlFor="breakPeriod" className="name">Break Period</label>
              <input
                type="number"
                id="break_period_value"
                name="break_period_value"
                value={formData.break_period_value}
                onChange={handleChange}
                style={{ margin: "0px", fontSize: '12px' }}
                min="0"
              />
            </div>
          
            {/* Dynamic input boxes based on break_period_value */}
           
            <div className='break-period-value-based' style={{display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '50px'}}>
              {formData.break_periods.map((value, index) => (
                <div key={index} style={{ display: 'flex', gap: '10px' }}>
                  <input 
                    type="text" 
                    value={`Period ${index + 1}`}
                    readOnly
                    style={{ margin: "0px", width: '270px', borderRadius: '8px', fontSize: '13px', backgroundColor: '#f5f5f5',textAlign:'center' }}
                  />
                  <input
                    type="number"
                    value={value || ''}
                    onChange={(e) => handleBreakPeriodChange(index, e.target.value)}
                    style={{ margin: "0px", width: '120px', borderRadius: '8px', fontSize: '12px',textAlign:'center' }}
                  />
                </div>
              ))}
            </div>
             <div className="project-period-popup-footer">
            <button type="button" className="clear-button" onClick={handleClear}>
              Clear
            </button>
            <button type="submit" className="submit-button">
              {isEditing ? "Update" : "Submit"}
            </button>
          </div>
          </div>

         
        </form>
      </div>
    </div>
  );
};

export default ProjectPeriodPopup;